import {
	Redirect,
	withRouter,
	Switch,
	Route,
	useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AccessRoute } from 'routing/AccessRoute';
import { getLifebooksHousesHash } from 'redux/selectors';
import { useMobileListCheck } from 'helpers';
import HomesListContainer from './components/HomesListContainer';
import { ManageHouse, Welcome } from 'components';
import styles from './homes.module.css';

function Home(props) {
	const { pathname } = useLocation();
	const houseHash = useSelector(getLifebooksHousesHash);
	const {
		basePath = '/homes',
		lifebookBasePath = '/lifebooks',
		resourceParentsBasePath = '/resource-parents',
		trustedCaseManagerRoute = false,
	} = props;

	const {
		match: {
			params: { houseId },
		},
	} = props;

	useMobileListCheck(pathname === `${basePath}/`);
	if (trustedCaseManagerRoute && houseId && !houseHash[houseId]) {
		return <Redirect to={`${basePath}/`} />;
	}

	return (
		<div className={styles.homesContainer}>
			<HomesListContainer
				basePath={basePath}
				caseManager={trustedCaseManagerRoute}
			/>
			<div className={styles.homesContent}>
				<Switch>
					{trustedCaseManagerRoute ? (
						<Route path={`${basePath}/manage/:houseId?`}>
							<ManageHouse
								basePath={basePath}
								lifebookBasePath={lifebookBasePath}
								resourceParentsBasePath={resourceParentsBasePath}
								caseManager
							/>
						</Route>
					) : (
						<AccessRoute
							key={`manageHome-${houseId}`}
							path={`${basePath}/manage/:houseId?`}
							authorized={{ agencyuser: true }}
							fallBackRoute={`${basePath}/`}
							component={ManageHouse}
						/>
					)}
					<Route path='/' component={Welcome} />
				</Switch>
			</div>
		</div>
	);
}

export default withRouter(Home);
